import api from './api';

/**
 * Profile Service
 * Handles all user profile-related API calls
 */
const profileService = {
    /**
     * Get my profile
     * @returns {Promise<Object>}
     */
    getProfile: async () => {
        return api.get('/user/profile');
    },

    /**
     * Update my profile
     * @param {Object} data - Profile data to update
     * @returns {Promise<Object>}
     */
    updateProfile: async (data) => {
        return api.put('/user/profile', data);
    },

    /**
     * Change password
     * @param {Object} data - { currentPassword, newPassword }
     * @returns {Promise<Object>}
     */
    changePassword: async (data) => {
        return api.patch('/user/profile/password', data);
    },

    /**
     * Upload avatar
     * @param {File} file - Avatar file
     * @returns {Promise<Object>}
     */
    uploadAvatar: async (file) => {
        const formData = new FormData();
        formData.append('avatar', file);
        return api.putMultipart('/user/profile', formData);
    },

    uploadHeroImage: async (file) => {
        const formData = new FormData();
        formData.append('heroImage', file);
        return api.putMultipart('/user/profile', formData);
    },

    /**
     * Delete account
     * @param {string} password - Current password for confirmation
     * @returns {Promise<Object>}
     */
    deleteAccount: async (password) => {
        return api.delete('/user/profile', { data: { password } });
    },

    /**
     * Get all settings (notifications, privacy, preferences)
     * @returns {Promise<Object>}
     */
    getSettings: async () => {
        return api.get('/user/profile/settings');
    },

    /**
     * Update notification settings
     * @param {Object} settings - Notification settings
     * @returns {Promise<Object>}
     */
    updateNotificationSettings: async (settings) => {
        return api.patch('/user/profile/notifications', settings);
    },

    /**
     * Update privacy settings
     * @param {Object} settings - Privacy settings
     * @returns {Promise<Object>}
     */
    updatePrivacySettings: async (settings) => {
        return api.patch('/user/profile/privacy', settings);
    },

    /**
     * Update preferences (language, theme)
     * @param {Object} preferences - User preferences
     * @returns {Promise<Object>}
     */
    updatePreferences: async (preferences) => {
        return api.patch('/user/profile/preferences', preferences);
    }
};

export default profileService;
